module.exports = __webpack_public_path__ + "static/media/cloud-computing 1.c77bba89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/cloud-computing 1.svg
// module id = 3199
// module chunks = 0